import { orderServiceListQuery, orderServiceCountQuery } from "./orderService";

const model = "vendor-events";

export const useVendorEventList = orderServiceListQuery({ model });
export const useVendorEventCount = orderServiceCountQuery({ model });
